"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiKit = require("@icis/ui-kit");
var _Item = _interopRequireDefault(require("./Item"));
var _List = require("./List.style");
var _l10n = require("../../../../../../../../l10n");
var _withLocale = _interopRequireDefault(require("../../../../../../../HOCs/withLocale"));
var _Spinner = _interopRequireDefault(require("../../../../../../../Spinner"));
var _SubMenu = require("../../../../../SubMenu/SubMenu.style");
const announcementsWidth = 400;
const AnnouncementsList = _ref => {
  let {
    isOpen,
    announcements,
    setAnnouncementListRef,
    maxListHeight,
    hasError,
    isLoading,
    noAnnouncements,
    refetch,
    locale
  } = _ref;
  return (
    /*#__PURE__*/
    // @ts-ignore
    _react.default.createElement(_List.AnnouncementsListWrapper, {
      ref: setAnnouncementListRef(),
      maxHeight: maxListHeight
    }, !hasError && !isLoading && announcements && announcements.map((announcement, index) => /*#__PURE__*/_react.default.createElement(_Item.default, {
      key: announcement.id,
      announcement: announcement,
      isOpen: isOpen,
      index: index + 1,
      listLength: announcements.length + 1,
      itemWidth: announcementsWidth
    })), isLoading &&
    /*#__PURE__*/
    // @ts-ignore
    _react.default.createElement(_SubMenu.SubMenuItem, {
      showing: isOpen,
      noHover: true,
      itemWidth: announcementsWidth
    }, /*#__PURE__*/_react.default.createElement(_SubMenu.SubMenuItemInner, {
      showing: isOpen,
      listLength: 2,
      index: 1
    }, /*#__PURE__*/_react.default.createElement(_Spinner.default, null))), noAnnouncements &&
    /*#__PURE__*/
    // @ts-ignore
    _react.default.createElement(_SubMenu.SubMenuItem, {
      showing: isOpen,
      noHover: true,
      itemWidth: announcementsWidth
    }, /*#__PURE__*/_react.default.createElement(_SubMenu.SubMenuItemInner, {
      showing: isOpen,
      listLength: 2,
      index: 1
    }, /*#__PURE__*/_react.default.createElement(_List.ErrorMessageWrapper, null, /*#__PURE__*/_react.default.createElement(_uiKit.Text.Body, null, (0, _l10n.getMessages)(locale)('Announcements.NoAnnouncements'))))), hasError &&
    /*#__PURE__*/
    // @ts-ignore
    _react.default.createElement(_SubMenu.SubMenuItem, {
      showing: isOpen,
      noHover: true,
      itemWidth: announcementsWidth
    }, /*#__PURE__*/_react.default.createElement(_SubMenu.SubMenuItemInner, {
      showing: isOpen,
      listLength: 2,
      index: 1
    }, /*#__PURE__*/_react.default.createElement(_List.ErrorMessageWrapper, null, /*#__PURE__*/_react.default.createElement(_uiKit.Text.Body, null, (0, _l10n.getMessages)(locale)('Announcements.LoadError')), /*#__PURE__*/_react.default.createElement(_List.RetryButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      size: "Large",
      onClick: refetch
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Text.H4, null, (0, _l10n.getMessages)(locale)('General.Reload'))))))))
  );
};
var _default = exports.default = (0, _withLocale.default)(AnnouncementsList);